// extracted by mini-css-extract-plugin
export default {"wrapper":"gameLogs_wrapper__Xla7y","number":"gameLogs_number__Bxa6U","log":"gameLogs_log__BjWTF"};